
import axios from 'axios'
import Conf from '../router/Conf'
import {
  Toast,
  Dialog
} from 'vant'
export let newAppFlag = false
export let chkAppVersion = function (ismanual) {
    plus.runtime.getProperty(plus.runtime.appid, function (inf) {
    localStorage.setItem('version', inf.version)
    var ver = inf.version;
    var useragt = navigator.userAgent;
    var ua = useragt.toLowerCase();
    var isiOS = !!useragt.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    var chkautodown = function (url, suff) {
        var arr = url.split(".");
        return (arr.length > 0 && arr[arr.length - 1] == suff)
      }
    var downloadapp = function (rep) {
       if (/iphone|ipad|ipod/.test(ua) || isiOS) { //苹果手机   
         var loadurl = rep.data.ios || (apiBaseUrl + "app/install.ipa");
         if (chkautodown(loadurl, 'plist') || chkautodown(loadurl, 'ipa')) {
           top.location.href = loadurl;
         } else {
           plus.runtime.openURL(loadurl)
         }
      } else {
         var loadurl = rep.data.android || (apiBaseUrl + "app/install.apk");
         if (chkautodown(loadurl, 'apk')) {
           plus.nativeUI.toast('正在准备环境，请稍候！');
        // plus.nativeUI.toast(i18n.t('upgrade.ready') );
           var dtask = plus.downloader.createDownload(loadurl, {}, function (d, status) {
          if (status == 200) {
            var path = d.filename; //下载apk
            plus.runtime.install(path); // 自动安装apk文件
          } else {
            plus.nativeUI.alert('版本更新失败' + status);
          }
        });
        dtask.start();
      }else{
           plus.runtime.openURL(loadurl)
      }
     }
   }
    var url = Conf.serverUrl + "Version/getVersionInfo";
    // console.log(url)
    axios.post(url).then(res => {
      if (res.data.code == 200) {
        var vers_info = res.data.data;
        if (ver != vers_info.version) {
          if (typeof newAppFlag != "undefined") {
            newAppFlag = true
          }
          var note = vers_info.note ? vers_info.note : ("发现新版本:V" + vers_info.version)
          if (vers_info.code == 1) {
            downloadapp(res.data);
          } else {
            Dialog.alert({
                className: "dialog-confirm",
                title: "版本升级",
                message: note,
                cancelButtonText: "下次再说",
                confirmButtonText: "马上升级",
                showConfirmButton: true,
                showCancelButton: true
              }).then(() => {
                downloadapp(res.data);
              })
              .catch(() => {});
          }
        } else {
          if (ismanual) {
            Dialog.alert({
                className: "dialog-confirm",
                title: "温馨提示",
                message: "当前已是最新版本",
                cancelButtonText: "重新下载",
                confirmButtonText: "知道了",
                showConfirmButton: true,
                showCancelButton: true
              }).then(() => {})
              .catch(() => {
                downloadapp(res.data);
              });
          }
        }

      } else if (ismanual) {
        Toast.success({
          message: '网络异常,请稍候再试...'
        })
      }
    })
  });
}



// WEBPACK FOOTER //
// ./src/utils/upgrade.js